module.exports = __webpack_public_path__ + "img/icon-bx-user-circle.c47c76de.svg";